import { FileText } from "lucide-react";
import React from "react";
import {
  Alert,
  Select,
  SimpleGrid,
  Space,
  Text,
  TextInput,
} from "@mantine/core";
import AuthProfile from "../../auth/services/model/AuthProfile";
import EmployeeImportConfigureNameSelect from "../elements/EmployeeImportConfigureNameSelect";

type EmployeeImportConfigPanelProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  auth: AuthProfile;
};

const EmployeeImportConfigPanel: React.FC<EmployeeImportConfigPanelProps> = ({
  form,
  auth,
}) => (
  <>
    <Space
      style={{
        paddingTop: "32px",
      }}
    />
    <Text
      style={{
        flexGrow: 0,
        fontFamily: "Inter",
        fontSize: "18px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "left",
        color: "var(--grey-grey-80)",
      }}
    >
      Confirm Import
    </Text>
    <Space h="lg" />
    <Text
      style={{
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.43",
        letterSpacing: "0.16px",
        textAlign: "left",
        color: "var(--grey-grey-70)",
      }}
    >
      You can match imported data to existing data using a unique reference.
    </Text>
    <Text
      style={{
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "1.43",
        letterSpacing: "0.16px",
        textAlign: "left",
        color: "var(--grey-grey-70)",
      }}
    >
      Save this configuration for future use.
    </Text>
    <Space h="xl" />
    <Alert
      style={{
        height: "52px",
        alignSelf: "stretch",
        flexGrow: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "stretch",
        gap: "8px",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#f0effe",
      }}
      icon={<FileText size={16} />}
    >
      <Text
        style={{
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "1.33",
          letterSpacing: "0.16px",
          textAlign: "left",
          color: "#625df5",
        }}
      >
        Filename:{" "}
        {form.values.file
          ? // eslint-disable-next-line dot-notation
            form.values.file["name"]
          : "-"}
      </Text>
    </Alert>
    <Space h="xl" />
    <div className="border border-gray-100">
      <Text
        style={{
          background: "#FCFCFC",
          padding: "20px 10px ",
          flexGrow: 0,
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: 500,
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "normal",
          letterSpacing: "0.16px",
          textAlign: "left",
          color: "var(--grey-grey-80)",
        }}
      >
        Import settings
      </Text>
      <Space h="xl" />

      <div className="p-4">
        <SimpleGrid cols={2}>
          <TextInput
            placeholder="Add a Name"
            label="Import Name"
            required
            sx={{ flex: 1 }}
            {...form.getInputProps("name")}
          />
          <Select
            required
            label="Matching data"
            placeholder="Select"
            data={[
              { value: "employee_no", label: "Employee Number" },
              { value: "id_number", label: "ID Number" },
              { value: "smartwage_id", label: "Jem ID" },
              { value: "id", label: "Database Number" },
              {
                value: "id_number_and_employee_number",
                label: "ID Number/Employee No",
              },
            ]}
            {...form.getInputProps("lookupHeader")}
          />

          <EmployeeImportConfigureNameSelect form={form} auth={auth} />
          <Select
            id="importAction"
            name="importAction"
            label="Actions"
            placeholder="Select"
            searchable
            clearable
            data={[
              {
                value: "create_update",
                label: "Create/Update",
              },
              {
                value: "create_update_delete",
                label: "Create/Update/Delete",
              },
            ]}
            {...form.getInputProps("importAction")}
            required
          />
        </SimpleGrid>
      </div>
    </div>
  </>
);

export default EmployeeImportConfigPanel;
